import { useQuery } from '@tanstack/react-query';
import axios from 'axios';

import { ResponseList } from 'models';
import { F1UserStatus } from 'models/user/Employee';

export type UseF1UserStatusRemarkProps = {
    enabled?: boolean;
    sid?: string;
    platformId?: string;
    username?: string;
};

export function useF1UserStatusRemark(props: UseF1UserStatusRemarkProps) {
    const { enabled, sid, platformId, username } = props;

    return useQuery({
        enabled,
        queryKey: ['f1-user-status-remark', { sid: sid, platform_id: platformId, username: username }],
        queryFn: ({ signal }) =>
            axios.get<ResponseList<F1UserStatus>>('/v1/f1/user/status-remark', {
                signal,
                params: {
                    sid,
                    platform_id: platformId,
                    username
                }
            }),
        select: response => response.data.result_list?.[0],
        retry: 1
    });
}
